// Decoder action types
export const DECODE_REQUEST = "DECODE_REQUEST"
export const DECODE_SUCCESS = "DECODE_SUCCESS"  
export const DECODE_FAILURE = "DECODE_FAILURE"

export const UPDATE_HEX_VALUE = "UPDATE_HEX_VALUE"
export const CLEAR_DECODER_STATE = "CLEAR_DECODER_STATE"

export const TOGGLE_BIT = "TOGGLE_BIT"
export const UPDATE_LOCAL_MATRIX = "UPDATE_LOCAL_MATRIX"

export const SET_DECODER_TYPE = "SET_DECODER_TYPE"
export const INITIALIZE_WITH_DEFAULT = "INITIALIZE_WITH_DEFAULT"

// TLV specific actions
export const TLV_PARSE_REQUEST = "TLV_PARSE_REQUEST"
export const TLV_PARSE_SUCCESS = "TLV_PARSE_SUCCESS"
export const TLV_PARSE_FAILURE = "TLV_PARSE_FAILURE"
export const TLV_CLEAR_STATE = "TLV_CLEAR_STATE"
export const TLV_UPDATE_HEX_VALUE = "TLV_UPDATE_HEX_VALUE"